import React, {
  useImperativeHandle,
  forwardRef,
  useEffect,
  useContext,
  useState,
} from "react";
import { Card, useMediaQuery, useTheme } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import MenuBar from "../common/MenuBar";
import { DataGrid } from "@mui/x-data-grid";
import { deleteEnquiryComment, getEnquiries } from "../API/EnquiryApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import authContext from "../Context/AuthProvider";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Edit from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { convertUTCToTimeZoneDateString } from "../Utility/DateTimeUtility";

import { capitalizeFirstLetter, formatAge } from "../Utility/Utility";
import {
  Button,
  Typography,
  CardContent,
  CardActions,
  Divider,
  IconButton,
} from "@mui/material";
import DateRangeDialog from "../Appointments/ChangeDates";
import dayjs from "dayjs";
import { DateRangeOptions } from "../Utility/Constants";
import { convertToUTC } from "../Utility/DateTimeUtility";
import { CloseOutlined, CreateOutlined } from "@mui/icons-material";

const EnquiryList = forwardRef(({ onNewEnquiry, onEditEnquiry }, ref) => {
  const { showSnackbar } = useSnackbar();
  const { auth } = useContext(authContext);
  // console.log("Auth context:", auth);
  const [showSpinner, setShowSpinner] = useState(false);
  const [enquiryRows, setenquiryRows] = useState([]);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [pageSize, setPageSize] = useState(20);

  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()).add(7, "days"),
    selectedDateRangeOption: DateRangeOptions.Next7Days,
    // statusList: appointmentStatusList,
  });
  // console.log(filters);

  const filterHardCoded = {
    facilityId: auth.selectedFacility.id,
    fromDate: convertToUTC(filters.from).startOf("day").toISOString(),
    toDate: convertToUTC(filters.to).endOf("day").toISOString(),
  };

  // console.log(filterHardCoded);

  const loadEnquiry = async () => {
    setShowSpinner(true);
    try {
      const result = await getEnquiries(auth, filterHardCoded);
      if (result.isSuccess) {
        setenquiryRows(result.data);
        console.log(result.data);
      } else {
        showSnackbar("Failed to load enquiry", "error");
      }
    } catch (error) {
      console.error("Error loading enquiries:", error);
      showSnackbar(
        "An unexpected error occurred while loading enquiries.",
        "error"
      );
    } finally {
      setShowSpinner(false);
    }
  };
  useEffect(() => {
    loadEnquiry();
  }, [auth, filters]);

  useImperativeHandle(ref, () => ({
    refreshEnquiryList: () => {
      console.log(" refreshEnquiryList called from parent");
      loadEnquiry();
    },
  }));

  const handleDeleteEnquiry = async (id) => {
    console.log(auth);

    const response = await deleteEnquiryComment(auth, id);
    if (response.isSuccess) {
      showSnackbar(" Enquiry deleted successfully!", "success");
      loadEnquiry(); // Refresh the list
    } else {
      showSnackbar(response.data || " Failed to delete Enquiry", "error");
    }
  };
  const enquiryColumns = [
    // { field: "displayId", headerName: "ID", width: 170 },
    {
      field: "displayId",
      headerName: "ID",
      width: 180,
      renderCell: (params) => (
        <span
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => onEditEnquiry(params.row)}
        >
          {params.row.displayId}
        </span>
      ),
    },
    {
      field: "name",
      headerName: "Full Name",
      flex: 1,
      renderCell: (params) => {
        const name = params.row.name || "";
        const gender = params.row.gender || "";
        const age = params.row.age || "";
        const phone = params.row.phoneNumber || "";
        const countryCode = params.row.countryCodeForPhone || "";

        return (
          <div
            style={{
              lineHeight: 1.4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div>
              <strong>{name}</strong>
              <span style={{ fontWeight: "normal" }}> ({gender})</span>
            </div>
            <span style={{ color: "#555", fontSize: "0.85em" }}>
              {`${countryCode} ${phone} (${formatAge(age)})`}
            </span>
          </div>
        );
      },
    },
    { field: "sourceCategory", headerName: "Main Source", flex: 1 },
    { field: "sourceNotes", headerName: "Source Detail", flex: 1 },
    { field: "enquiryType", headerName: "Category", flex: 1 },
    {
      field: "followUpDate",
      headerName: "Follow Up Date",
      flex: 1,
      renderCell: (params) => (
        <div>
          {params &&
            convertUTCToTimeZoneDateString(
              params.row.followUpDate,
              auth?.selectedFacility?.timeZone
            )}
        </div>
      ),
    },
    {
      field: "query",
      headerName: "Query",
      flex: 2.5,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "normal", // allow wrapping
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.4,
            fontSize: "0.95rem",
          }}
        >
          <p style={{ margin: 0 }}>
            {params?.value?.length <= 100
              ? params.value
              : `${params?.value?.slice(0, 100)}...`}
          </p>
        </div>
      ),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   width: 100,
    //   renderCell: (params) => (
    //     <>
    //       <Tooltip title="Edit Enquiry" arrow>
    //         <IconButton onClick={() => onEditEnquiry(params?.row)}>
    //           <EditIcon fontSize="small" />
    //         </IconButton>
    //       </Tooltip>

    //       {/* <Tooltip title="Remove Enquiry" arrow>
    //         <IconButton onClick={() => handleDeleteEnquiry(params.row.id)}>
    //           <DeleteOutlineIcon fontSize="small" />
    //         </IconButton>
    //       </Tooltip> */}
    //     </>
    //   ),
    // },
  ];

  //update the card when server error are resolved, this is a simple template...
  const renderEnquiryCards = () => (
    <Card sx={{ px: 1 }}>
      {enquiryRows.map((data) => (
        <Card key={data.id} variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
          <CardContent>
            <div>
              <Typography variant="h6">
                {capitalizeFirstLetter(data.name)} ({data.age})
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {data.countryCodeForPhone} {data.phoneNumber} ({data.gender})
                <br />
                {data.email}
              </Typography>
            </div>
            <Divider sx={{ my: 1 }} />
            {/* <Typography variant="body2" gutterBottom>
              ID : {data.displayId}
            </Typography> */}
            <Typography
              variant="body2"
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => onEditEnquiry(data)}
            >
              ID : {data.displayId}
            </Typography>
            <Typography variant="body2">
              Source : {data.sourceCategory}
            </Typography>
            <Typography variant="body2">
              Sub-source : {data.sourceSubCategory}
            </Typography>
            <Typography variant="body2">
              Source Notes : {data.sourceNotes}
            </Typography>
            <Typography variant="body2">
              Enquiry Type : {data.enquiryType}{" "}
            </Typography>
            <Typography variant="body2">Query : {data.query} </Typography>
          </CardContent>

          <CardActions
            sx={{ justifyContent: "flex-end", px: 2, pb: 2, mt: -1 }}
          >
            <Tooltip title="Edit Enquiry" arrow>
              <IconButton
                size="small"
                color="primary"
                onClick={() => onEditEnquiry(data)}
              >
                <CreateOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
            {/* <Tooltip title="Remove Enquiry" arrow>
              <IconButton
                size="small"
                color="secondary"
                onClick={() => handleDeleteEnquiry(data.id)}
              >
                <CloseOutlined fontSize="small" />
              </IconButton>
            </Tooltip> */}
          </CardActions>
        </Card>
      ))}
    </Card>
  );

  return (
    <Grid2
      container
      sx={{
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
      }}
    >
      <MenuBar
        key="EnquiryList"
        changeDateDialogKey="EnquiryList"
        showChangeDate={true}
        onChangeDate={() => setOpenDateRangeDialog(true)}
        showNew={true}
        onNew={onNewEnquiry}
        newLabel="New Enquiry"
        newTooltip="New Enquiry"
      />
      {/* date display */}
      <Grid2 size={12} sx={{ px: 1, py: 0.5 }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: "0.75rem",
              sm: "0.875rem",
              md: "1rem",
              lg: "1.125rem",
              xl: "1.25rem",
            },
          }}
        >
          Showing Enquiry from {filters?.from?.format("DD/MM/YYYY")} to{" "}
          {filters?.to?.format("DD/MM/YYYY")}
        </Typography>
      </Grid2>
      <Card sx={{ width: "100%", px: "5px", boxShadow: "none", mt: 0.5 }}>
        <Card sx={{ width: "100%", paddingX: "5px", boxShadow: "none" }}>
          {isMobile ? (
            renderEnquiryCards()
          ) : (
            <DataGrid
              localeText={{
                noRowsLabel:
                  "There are no Enquiry to display. Change the dates or create a new Enquiry.",
              }}
              loading={showSpinner}
              slotProps={{
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
              }}
              initialState={{
                density: "compact",
                pagination: {
                  paginationModel: { pageSize: 20 }, // Default page size
                },
              }}
              sx={{
                width: "100%",
                "& .sticky-column": {
                  position: "sticky",
                  right: 0, // Keep it on the right side
                  backgroundColor: "white", // To make sure it has a solid background
                  zIndex: 100, // Ensure it stays on top of other columns
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "unset",
                  alignItems: "center",
                  paddingTop: "0 !important",
                  paddingBottom: "0 !important",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    margin: 0,
                  },
              }}
              rowHeight={60}
              rows={enquiryRows}
              columns={enquiryColumns}
              pageSizeOptions={[5, 10, 15 , 20]}
              rowsPerPageOptions={[5, 10, 15, 20]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          )}
        </Card>
      </Card>
      <div>
        <DateRangeDialog
          key="Enquiry"
          title="Show Enquiry For"
          filters={filters}
          setFilters={setFilters}
          openState={openDateRangeDialog}
          setOpenState={setOpenDateRangeDialog}
        ></DateRangeDialog>
      </div>
    </Grid2>
  );
});

export default EnquiryList;
